// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalCloseButton__button--da15 {
    position: absolute;
    top: 16px;
    right: 24px;
    width: 40px;
    top: 16px;
    right: 16px;
    border: 1px solid var(--dark-tertiary-new-color);
}

    @media screen and (min-width: 1024px) {.ModalCloseButton__button--da15 {
        top: 24px;
        right: 24px
}
    }`, "",{"version":3,"sources":["webpack://./src/ui/components/ModalCloseButton/ModalCloseButton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,SAAS;IACT,WAAW;IACX,gDAAgD;AAMpD;;IAJI,uCATJ;QAUQ,SAAS;QACT;AAER;IADI","sourcesContent":[".button {\n    position: absolute;\n    top: 16px;\n    right: 24px;\n    width: 40px;\n    top: 16px;\n    right: 16px;\n    border: 1px solid var(--dark-tertiary-new-color);\n\n    @media (--large) {\n        top: 24px;\n        right: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ModalCloseButton__button--da15`
};
export default ___CSS_LOADER_EXPORT___;
